import { jsx } from "@ecopages/jsx/jsx-runtime";
import "./toc.script";
export function RuiToc(props) {
  return /* @__PURE__ */jsx("rui-toc", {
    ...props
  });
}